// NTO toolkit: dots as a language.
// Three dots make an arrow, four the menu diamond, five the close cross.
// Positions are the portfolio's (Contact.tsx, Menu.tsx), at their real size.
import * as React from "react"

export type DotShape = "arrow" | "arrowLeft" | "diamond" | "cross" | "dot"

const SHAPES: Record<DotShape, { at: [number, number][]; size: number; w: number; h: number }> = {
    // the send arrow: 13 × 19.5, dots 3.9
    arrow: { at: [[0, 0], [0, 15.6], [9.1, 7.8]], size: 3.9, w: 13, h: 19.5 },
    arrowLeft: { at: [[9.1, 0], [9.1, 15.6], [0, 7.8]], size: 3.9, w: 13, h: 19.5 },
    // the menu diamond: 7 from the centre, dots 3
    diamond: { at: [[7, 0], [14, 7], [7, 14], [0, 7]], size: 3, w: 17, h: 17 },
    // the sent cross: 19.9 square, dots 3.9
    cross: { at: [[0, 0], [16, 0], [8, 8], [0, 16], [16, 16]], size: 3.9, w: 19.9, h: 19.9 },
    dot: { at: [[0, 0]], size: 3.9, w: 3.9, h: 3.9 },
}

type Props = {
    shape: DotShape
    /** dot colour; defaults to the text colour */
    color?: string
    className?: string
    style?: React.CSSProperties
}

export function Dots({ shape, color = "currentColor", className, style }: Props) {
    const s = SHAPES[shape]
    return (
        <span
            className={"nto-dots" + (className ? " " + className : "")}
            aria-hidden="true"
            style={{ position: "relative", display: "inline-block", width: s.w, height: s.h, flex: "none", ...style }}
        >
            {s.at.map(([l, t], k) => (
                <i
                    key={k}
                    style={{
                        position: "absolute",
                        left: l,
                        top: t,
                        width: s.size,
                        height: s.size,
                        borderRadius: "50%",
                        background: color,
                        ["--i" as any]: k,
                    }}
                />
            ))}
        </span>
    )
}
